import { FcGoogle } from 'react-icons/fc'; // This icon is good!
import { useTranslation } from 'react-i18next';


export default function GoogleLoginButton() {
  const {t} = useTranslation('auth')
  const translation = t('google_auth')

  const handleClick = () => {
    window.location.href = `${process.env.REACT_APP_BACKEND_DOMAIN}/user/google-login-redirect/`;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="
        flex items-center justify-center w-full
        py-2 px-4 border border-gray-300 dark:border-gray-100 rounded-md shadow-sm
        text-sm font-medium
        bg-white dark:bg-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
        transition duration-200 ease-in-out
        text-gray-700 dark:text-gray-200
      "
      aria-label="Continue with Google" 
    >
      <FcGoogle className="h-5 w-5 mr-2" /> 
      <span>{translation.continue_with_google}</span>
    </button>
  );
}